import preset from '@bit/medicalwebexperts.mwe-ui.themes.preset';
import {
  MdLock,
  MdPerson,
  MdTune,
  MdVisibility,
  MdVisibilityOff,
  MdPersonAdd,
  MdDeleteForever,
} from 'react-icons/md';

import { IoMdCalendar } from 'react-icons/io';
import { GiTestTubes } from 'react-icons/gi';

export default {
  ...preset,
  fonts: {
    ...preset.fonts,
    body: 'Roboto, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif',
    heading:
      'Roboto, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif',
  },
  typography: {
    h1: {
      fontFamily: 'heading',
      fontSize: '4xl',
      fontWeight: 'normal',
      lineHeight: 'base',
      color: 'black',
    },
    h5: {
      fontFamily: 'heading',
      fontSize: 'xl',
      fontWeight: 'normal',
      lineHeight: 'base',
      color: 'black',
    },
    subtitle1: {
      fontFamily: 'heading',
      fontSize: 'lg',
      fontWeight: 'medium',
      lineHeight: 'base',
    },
    body1: {
      fontFamily: 'body',
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'base',
    },
    body2: {
      fontFamily: 'body',
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: 'base',
    },
    caption: {
      fontFamily: 'body',
      fontSize: 'xs',
      fontWeight: 'normal',
      lineHeight: 'base',
    },
    inherit: {},
  },
  colors: {
    ...preset.colors,
    background: '#f9f9f9',
    primary: {
      light: '#ffce86',
      main: '#faaf3f',
      dark: '#c68422',
    },
    secondary: {
      light: '#dbedfc',
      main: '#5889b1',
      dark: '#b7d9f4',
    },
  },
  shadows: {
    ...preset.shadows,
    appbar: '0 2px 6px rgba(0, 0, 0, 0.1)',
  },
  sizes: {
    ...preset.sizes,
    sidebar: '240px',
  },
  icons: {
    ...preset.icons,
    lock: MdLock,
    person: MdPerson,
    addperson: MdPersonAdd,
    search: MdTune,
    visible: MdVisibility,
    visibleOff: MdVisibilityOff,
    trash: MdDeleteForever,
    calendar: IoMdCalendar,
    test: GiTestTubes,
  },
};
